import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CategoryConfigurationInheritanceStructureDto } from '@rocksoft/settings-sdk';

export type CategoryConfigurationInheritedState = EntityState<CategoryConfigurationInheritanceStructureDto>;

export function selectId(configuration: CategoryConfigurationInheritanceStructureDto) {
  return configuration.categoryConfiguration?.id ?? '';
}

export const adapter: EntityAdapter<CategoryConfigurationInheritanceStructureDto> =
  createEntityAdapter<CategoryConfigurationInheritanceStructureDto>({
    selectId,
  });

export const initialState: CategoryConfigurationInheritedState = adapter.getInitialState();
